import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useRouteError } from 'react-router'
import { Button, Typography } from 'flipper-ui'
import { IconErrorOutline } from 'flipper-ui/icons/mui'
import { Content } from './styles'

const STALE_CHUNK =
    /ChunkLoadError|Loading chunk|dynamically imported module|Importing a module script failed/i

const RouteError = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const error = useRouteError()

    const reason = error instanceof Error ? error.message : String(error)
    const isStaleChunk = STALE_CHUNK.test(reason)

    useEffect(() => {
        if (isStaleChunk) {
            return
        }

        console.error('[portal] route render failed', error)
    }, [error, isStaleChunk])

    const message = isStaleChunk
        ? t('error:staleVersion')
        : t('error:contentError')

    const action = isStaleChunk
        ? { label: 'Recarregar', onClick: () => window.location.reload() }
        : { label: t('common:back'), onClick: () => navigate(-1) }

    return (
        <Content>
            <IconErrorOutline color='disabled' fontSize='large' />
            <Typography
                variant='h5'
                align='center'
                maxWidth='620px'
                color='textSecondary'
                margin='24px 0 16px 0'>
                {message}
            </Typography>
            <Button variant='outlined' color='primary' onClick={action.onClick}>
                {action.label}
            </Button>
        </Content>
    )
}

export default RouteError
